import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput, Card } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { API } from "../../../../../global/global";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaPsicologicaInterface } from "../../../../../interfaces/FechaPsicologicaInterface";
import { ConclusionLlenadaPSInterface } from "../../../../../interfaces/ConclusionLlenadaPSInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const EvaluacionPsicologica1ListaPrint = () => {
  const tituloFormulario = "EVALUACIÓN PSICOLÓGICA";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const formFields = [
    { label: "NOMBRE:", id: "nombre" },
    { label: "DOMICILIO:", id: "domicilio" },
    { label: "TELÉFONO:", id: "telefono" },
    { label: "OCUPACIÓN:", id: "ocupacion" },
    { label: "AÑOS DE CONOCER AL EVALUADO:", id: "anios-conocerlo" },
    { label: "COMENTARIOS:", id: "comentarios" },
    { label: "LO RECOMIENDA:", id: "como-conoce" },
  ];

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaPS = useGetData<FechaPsicologicaInterface[]>({
    url: `/fecha_psico/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_psico"],
  });

  const queryConclusionPS = useGetData<ConclusionLlenadaPSInterface>({
    url: `/conclusionllenada_ps/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_ps"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaPS.data && queryFechaPS.data.length > 0) {
      const fechaps = queryFechaPS.data[0];
      reset({
        fecha_evaluacionps: fechaps.fecha_evaluacionps || "",
      });
    }
  }, [queryFechaPS.data, reset]);

  useEffect(() => {
    if (queryConclusionPS.data) {
      reset({
        conforma_ps: queryConclusionPS.data.conforma_ps || "",
        integrantes_ps: queryConclusionPS.data.integrantes_ps || "",
        identifica_ps: queryConclusionPS.data.identifica_ps || "",
        familiaporque_ps: queryConclusionPS.data.familiaporque_ps || "",
        relacionfam_ps: queryConclusionPS.data.relacionfam_ps || "",
        personalidad_ps: queryConclusionPS.data.personalidad_ps || "",
        describe_ps: queryConclusionPS.data.describe_ps || "",
        formaser_ps: queryConclusionPS.data.formaser_ps || "",
        personas_identificaps:
          queryConclusionPS.data.personas_identificaps || "",
        conocedrogas_ps: queryConclusionPS.data.conocedrogas_ps || "",
        consumealcohol_ps: queryConclusionPS.data.consumealcohol_ps || "",
        cuandoconsume_ps: queryConclusionPS.data.cuandoconsume_ps || "",
        procedimientosadm_ps: queryConclusionPS.data.procedimientosadm_ps || "",
        opinionpersona_ps: queryConclusionPS.data.opinionpersona_ps || "",
        mejor_ps: queryConclusionPS.data.mejor_ps || "",
        peor_ps: queryConclusionPS.data.peor_ps || "",
        motivoenojo_ps: queryConclusionPS.data.motivoenojo_ps || "",
        agredido_ps: queryConclusionPS.data.agredido_ps || "",
        riñaparticipo_ps: queryConclusionPS.data.riñaparticipo_ps || "",
        cualriña_ps: queryConclusionPS.data.cualriña_ps || "",
        estadoanimo_ps: queryConclusionPS.data.estadoanimo_ps || "",
        acontecimientotriste_ps:
          queryConclusionPS.data.acontecimientotriste_ps || "",
        tristezavida_ps: queryConclusionPS.data.tristezavida_ps || "",
        estadosalud_ps: queryConclusionPS.data.estadosalud_ps || "",
        tratamientomedico_ps: queryConclusionPS.data.tratamientomedico_ps || "",
        tratamientops_ps: queryConclusionPS.data.tratamientops_ps || "",
        motivo_ps: queryConclusionPS.data.motivo_ps || "",
        enterovacante_ps: queryConclusionPS.data.enterovacante_ps || "",
        problemasempresa_ps: queryConclusionPS.data.problemasempresa_ps || "",
        resolverproblemas_ps: queryConclusionPS.data.resolverproblemas_ps || "",
        reseñaempleos_ps: queryConclusionPS.data.reseñaempleos_ps || "",
        descripciongustatrabajo_ps:
          queryConclusionPS.data.descripciongustatrabajo_ps || "",
        descripciondisgustatrabajo_ps:
          queryConclusionPS.data.descripciondisgustatrabajo_ps || "",
        relacionjefecomp_ps: queryConclusionPS.data.relacionjefecomp_ps || "",
        situaciontrabajo_ps: queryConclusionPS.data.situaciontrabajo_ps || "",
        logropersonal_ps: queryConclusionPS.data.logropersonal_ps || "",
        logrolaboral_ps: queryConclusionPS.data.logrolaboral_ps || "",
        situacionimprevista_ps:
          queryConclusionPS.data.situacionimprevista_ps || "",
        tiempolibre_ps: queryConclusionPS.data.tiempolibre_ps || "",
        adaptacion_ps: queryConclusionPS.data.adaptacion_ps || "",
        manifiesta_ps: queryConclusionPS.data.manifiesta_ps || "",
        indicaacude_ps: queryConclusionPS.data.indicaacude_ps || "",
        adaptaequipo_psconforma_ps:
          queryConclusionPS.data.adaptaequipo_ps || "",
        tomadecision_ps: queryConclusionPS.data.tomadecision_ps || "",
        tolerancia_ps: queryConclusionPS.data.tolerancia_ps || "",
        compromiso_ps: queryConclusionPS.data.compromiso_ps || "",
        lider_ps: queryConclusionPS.data.lider_ps || "",
        ocasion_ps: queryConclusionPS.data.ocasion_ps || "",
        derivado2_ps: queryConclusionPS.data.derivado2_ps || "",
        objetivos_ps: queryConclusionPS.data.objetivos_ps || "",
        conseguirobj_ps: queryConclusionPS.data.conseguirobj_ps || "",
        observaciones_ps: queryConclusionPS.data.observaciones_ps || "",
        evaluado_uuid: queryConclusionPS.data.evaluado_uuid || "",
        noidentifica_ps: queryConclusionPS.data.noidentifica_ps || "",
        tipodrogas_ps: queryConclusionPS.data.tipodrogas_ps || "",
        actividadesempresa_ps:
          queryConclusionPS.data.actividadesempresa_ps || "",
        infoadicional_ps: queryConclusionPS.data.infoadicional_ps || "",
        valoresusted_ps: queryConclusionPS.data.valoresusted_ps || "",
      });
    }
  }, [queryConclusionPS.data, reset]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_evaluacionps" className="mr-2">
              FECHA:
            </Label>
            <Controller
              name="fecha_evaluacionps"
              control={control}
              defaultValue=""
              render={({ field }) => {
                const formatDate = (dateString: string): string => {
                  if (!dateString) return "";
                  const date = new Date(dateString + "T00:00:00");
                  return isNaN(date.getTime())
                    ? ""
                    : date.toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      });
                };

                return (
                  <TextInput
                    id="fecha_evaluacionps"
                    name="fecha_evaluacionps"
                    value={
                      field.value ||
                      (queryFechaPS.data && queryFechaPS.data.length > 0
                        ? formatDate(queryFechaPS.data[0]?.fecha_evaluacionps)
                        : "")
                    }
                    disabled={true}
                  />
                );
              }}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-[10px]"></div>
      <div className="flex justify-center items-center bg-gradient-to-r from-blue-600 to-blue-600 rounded-t">
        <div className="max-w-4xl w-full py-2 px-6">
          <div className="flex justify-center items-center">
            {" "}
            {/* Título */}
            <h1 className="text-2xl font-bold text-white tracking-tight">
              Evaluación Psicológica
            </h1>
          </div>
        </div>
      </div>
      <div className="space-y-6 p-6 bg-gray-50 rounded-lg">
        {/* Tabla */}
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border-2 border-gray-500 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border border-gray-300 text-center">
                  ÁMBITO FAMILIAR
                </th>
                <th className="py-3 px-4 border border-gray-300 text-center">
                  PERSONALIDAD
                </th>
                <th className="py-3 px-4 border border-gray-300 text-center">
                  HÁBITOS
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Estado Civil
                </th>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Describa como es su carácter
                </th>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  ¿Qué tipo de drogas conoce?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300">
                  <textarea
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    value={
                      queryEvaluado.data?.estado_civil
                        ? queryEvaluado.data.estado_civil
                            .charAt(0)
                            .toUpperCase() +
                          queryEvaluado.data.estado_civil.slice(1)
                        : ""
                    }
                    disabled={true}
                    placeholder="Estado Civil"
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="personalidad_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="personalidad_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.personalidad_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Personalidad"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="tipodrogas_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tipodrogas_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tipodrogas_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Personalidad"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-3 px-4 border border-gray-300 text-center">
                  Integrantes de su Familia
                </th>
                <th className="py-3 px-4 border border-gray-300 text-center">
                  AUTODESCRIPCIÓN
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="integrantes_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="integrantes_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.integrantes_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Integrantes"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="describe_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="describe_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.describe_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Descripción"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <div className="mt-2">
        <div className="flex items-center gap-2">
          <Label
            htmlFor="nombreFirma"
            className="text-sm font-semibold whitespace-nowrap ml-auto"
          >
            Nombre y Firma del Evaluado:
          </Label>
          <TextInput
            id="nombreFirma"
            name="nombreFirma"
            className="w-64 rounded-md py-1 text-sm"
          />
        </div>
      </div>
      <div className="space-y-6 p-6 rounded-lg">
        <div className="w-full overflow-x-auto">
          <table>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border border-gray-300 text-center">
                  ¿Con quién se identifica de su familia y por qué?
                </th>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  ¿Qué es lo que más le han criticado de su forma de ser?
                </th>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Describa las situaciones en que consume alcohol
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="identifica_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="identifica_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.identifica_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Razón de identificación"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="formaser_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="formaser_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.formaser_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Críticas recibidas"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="cuandoconsume_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="cuandoconsume_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.cuandoconsume_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Cuando..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Describa como es la relación con su familia
                </th>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  RELACIONES INTERPERSONALES
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="relacionfam_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="relacionfam_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.relacionfam_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Relación con la familia"
                      />
                    )}
                  />
                </td>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Describe como son las personas con las que se identifica
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300"></td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="personas_identificaps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="personas_identificaps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.personas_identificaps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Se identifica"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300"></td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300"></td>
                <th className="py-2 px-4 border border-gray-300 text-center">
                  Describa como son las personas con las que no se lleva bien
                </th>
                <td className="py-2 px-4 border border-gray-300"></td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border border-gray-300"></td>
                <td className="py-2 px-4 border border-gray-300">
                  <Controller
                    name="noidentifica_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="noidentifica_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.noidentifica_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Como son?"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border border-gray-300"></td>
              </tr>
            </thead>
          </table>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-center">
                  APEGO A NORMAS Y VALORES
                </th>
                <th className="py-3 px-4 border-b text-center">
                  CONTROL DE IMPULSOS
                </th>
                <th className="py-3 px-4 border-b text-center">SALUD</th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Procedimientos administrativos o jurídicos
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Explique cuales son los motivos por lo que se enoja
                </th>
                <th className="py-2 px-4 border-b text-center">
                  ¿Cómo considera su estado de salud?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="procedimientosadm_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="procedimientosadm_ps"
                        value={
                          field.value ||
                          (queryConclusionPS.data?.procedimientosadm_ps
                            ? "Si"
                            : "No")
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="procedimientosadm_ps"
                        placeholder="¿Si o No?"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="motivoenojo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="motivoenojo_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.motivoenojo_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="motivoenojo_ps"
                        placeholder="Describe los motivos de enojo aquí..."
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="estadosalud_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="estadosalud_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.estadosalud_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Estado de salud"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué me dirían sus jefes y maestros de usted?
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Describa cómo reacciona cuando es agredido
                </th>
                <th className="py-2 px-4 border-b text-center">Enfermedades</th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="opinionpersona_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="opinionpersona_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.opinionpersona_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Opinión..."
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="agredido_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="agredido_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.agredido_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Reacción al ser agredido"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tratamientomedico_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tratamientomedico_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.tratamientomedico_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Tratamiento Médico"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa que es lo mejor que ha hecho hasta hoy
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Cuénteme como fue la última riña en la que participó
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Tratamientos médicos prolongados
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="mejor_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="mejor_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.mejor_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Lo mejor que ha hecho"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="cualriña_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="cualriña_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.cualriña_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Riñas..."
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="derivado1_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="derivado1_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.derivado1_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Enfermedades"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa que es lo peor que ha hecho hasta hoy
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Describa como es su estado de ánimo actual
                </th>
                <th className="py-2 px-4 border-b text-center">
                  Tratamientos psicológicos o psiquiátricos
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="peor_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="peor_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.peor_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Lo peor que ha hecho"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="estadoanimo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="estadoanimo_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.estadoanimo_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Animo..."
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tratamientops_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tratamientops_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tratamientops_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Psicológico/psiquiátrico"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b"></td>
                <th className="py-2 px-4 border-b text-center">
                  Describa el acontecimiento más triste que ha vivido
                </th>
                <td className="py-2 px-4 border-b"></td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b"></td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="acontecimientotriste_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="acontecimientotriste_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.acontecimientotriste_ps ||
                            ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Acontecimiento mas triste"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b"></td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b"></td>
                <th className="py-2 px-4 border-b text-center">
                  ¿Cómo se refleja la tristeza en su vida cotidiana?
                </th>
                <td className="py-2 px-4 border-b"></td>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b"></td>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tristezavida_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tristezavida_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tristezavida_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Como se refleja la tristeza"
                      />
                    )}
                  />
                </td>
                <td className="py-2 px-4 border-b"></td>
              </tr>
            </thead>
          </table>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-center">
                  ÁMBITO LABORAL
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cuál es el motivo por el que entró a trabajar a la empresa?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="motivo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="motivo_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.motivo_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Motivo de entrar a la empresa"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cómo se enteró de la vacante?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="enterovacante_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="enterovacante_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.enterovacante_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Cómo se enteró de la vacante"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué actividades realiza en la empresa?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="actividadesempresa_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="actividadesempresa_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.actividadesempresa_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Actividades..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué opina de los problemas que se pueden presentar en la
                  empresa?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="problemasempresa_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="problemasempresa_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.problemasempresa_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Problemas en la empresa"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cómo puede contribuir a resolverlos?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="resolverproblemas_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="resolverproblemas_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.resolverproblemas_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Cómo contribuiría a resolverlos"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cuáles fueron sus empleos anteriores?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="reseñaempleos_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="reseñaempleos_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.reseñaempleos_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Empleos anteriores"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa lo que más le gustaba de su último trabajo
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="descripciongustatrabajo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="descripciongustatrabajo_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data
                              ?.descripciongustatrabajo_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="descripciongustatrabajo_ps"
                        placeholder="Descripción de su último trabajo..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa lo que menos le gustaba de su último trabajo
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="descripciondisgustatrabajo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="descripciondisgustatrabajo_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data
                              ?.descripciondisgustatrabajo_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="descripciondisgustatrabajo_ps"
                        placeholder="Descripción de su último trabajo..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa como ha sido su relación con jefes y compañeros
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="relacionjefecomp_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="relacionjefecomp_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.relacionjefecomp_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Relación con jefes y compañeros"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cuál es la situación más difícil que ha enfrentado en el
                  trabajo?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="situaciontrabajo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="situaciontrabajo_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.situaciontrabajo_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Situación difícil en el trabajo"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa su mayor logro personal y laboralmente
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="logropersonal_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="logropersonal_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.logropersonal_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="descripciondisgustatrabajo_ps"
                        placeholder="Mayor logro personal y laboral"
                      />
                    )}
                  />
                  <Controller
                    name="logrolaboral_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="logrolaboral_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.logrolaboral_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        aria-label="descripciondisgustatrabajo_ps"
                        placeholder="Mayor logro personal y laboral"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Describa una situación imprevista o bajo presión en la que
                  tuvo que tomar decisiones, como actuó y qué resultados obtuvo
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="situacionimprevista_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="situacionimprevista_ps"
                        value={
                          field.value ||
                          `${
                            queryConclusionPS.data?.situacionimprevista_ps || ""
                          }`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Situación difícil en el trabajo"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué actividades realiza en su tiempo libre?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tiempolibre_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tiempolibre_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tiempolibre_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Actividades en tiempos libres"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Información adicional y/o comentarios
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="infoadicional_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="infoadicional_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.infoadicional_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="Información..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-center">
                  COMPETENCIAS LABORALES
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-400 text-black">
                <th className="py-3 px-4 border-b text-center">
                  ADAPTABILIDAD
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué tan rápido o lento es que usted se adapte a nuevas
                  actividades y a los cambios tanto laborales como sociales?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="adaptacion_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="adaptacion_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.adaptacion_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Que tanto?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-400 text-black">
                <th className="py-3 px-4 border-b text-center">
                  RESPONSABILIDAD
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cumple con la entrega de los trabajos encomendados el día y
                  hora que se requiere?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="manifiesta_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="manifiesta_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.manifiesta_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Cumple?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Acude a su trabajo en los horarios establecidos de manera
                  puntual?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="indicaacude_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="indicaacude_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.indicaacude_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Acude?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-400 text-black">
                <th className="py-3 px-4 border-b text-center">
                  TRABAJO EN EQUIPO
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Con qué facilidad se adapta usted a trabajar en equipo?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b text-center">
                  <Controller
                    name="adaptaequipo_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="adaptaequipo_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.adaptaequipo_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Con que facilidad?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-left">
                  TOMA DE DECISIONES
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b">
                  ¿En situaciones de emergencia en sus actividades laborales,
                  toma usted decisiones asertivas y rápidas para la solución de
                  conflictos?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tomadecision_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tomadecision_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tomadecision_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                        placeholder="¿Lo hace?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-left">
                  TOLERANCIA A LA PRESIÓN
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b">
                  Mencione un proyecto desafiante, con una fecha límite
                  ajustada, explique los métodos que se tomaron y realce los
                  resultados
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="tolerancia_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="tolerancia_ps"
                        value={
                          field.value ||
                          `${queryConclusionPS.data?.tolerancia_ps || ""}`
                        }
                        disabled={true}
                        onChange={field.onChange}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        aria-label="tolerancia_ps"
                        placeholder="Descripción..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>

          <div className="w-full overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-blue-500 text-black">
                  <th className="py-3 px-4 border-b text-left">
                    COMPROMISO LABORAL
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-200 text-black">
                  <th className="py-2 px-4 border-b">
                    ¿Sientes que tu trabajo tiene un propósito y contribuye al
                    éxito de la empresa?
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="text-black">
                  <td className="py-2 px-4 border-b">
                    <Controller
                      name="compromiso_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="compromiso_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.compromiso_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          aria-label="tolerancia_ps"
                          placeholder="Descripción..."
                        />
                      )}
                    />
                  </td>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-500 text-black">
                  <th className="py-3 px-4 border-b text-left">LIDERAZGO</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-200 text-black">
                  <th className="py-2 px-4 border-b">
                    Mencione brevemente un momento en el que demostró sus
                    habilidades de liderazgo
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="text-black">
                  <td className="py-2 px-4 border-b">
                    <Controller
                      name="lider_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="lider_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.lider_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          aria-label="lider_ps"
                          placeholder="Descripción..."
                        />
                      )}
                    />
                  </td>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-200 text-black">
                  <th className="py-2 px-4 border-b">
                    ¿Qué valores son los más importantes para usted como líder?
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="text-black">
                  <td className="py-2 px-4 border-b">
                    <Controller
                      name="valoresusted_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="valoresusted_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.valoresusted_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          aria-label="valoresusted_ps"
                          placeholder="¿Cuáles?"
                        />
                      )}
                    />
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <br />
          <br />
          <br />
          <div className="mt-2">
            <div className="flex items-center gap-2">
              <Label
                htmlFor="nombreFirma"
                className="text-sm font-semibold whitespace-nowrap ml-auto"
              >
                Nombre y Firma del Evaluado:
              </Label>
              <TextInput
                id="nombreFirma"
                name="nombreFirma"
                className="w-64 rounded-md py-1 text-sm"
              />
            </div>
          </div>
          <div className="w-full overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-blue-500 text-black">
                  <th className="py-3 px-4 border-b text-left">INICIATIVA</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-200 text-black">
                  <th className="py-2 px-4 border-b">
                    En alguna ocasión, ha tenido que asumir mayor
                    responsabilidad en tu trabajo, ¿de lo que te correspondía?
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="text-black">
                  <td className="py-2 px-4 border-b">
                    <Controller
                      name="ocasion_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="ocasion_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.ocasion_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          type="text"
                          className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                          placeholder="Ocasión responsabilidad"
                        />
                      )}
                    />{" "}
                    ¿Porque?{" "}
                    <Controller
                      name="derivado2_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="derivado2_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.derivado2_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          type="text"
                          className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                          placeholder="Razón responsabilidad"
                        />
                      )}
                    />
                  </td>
                </tr>
              </thead>
              <thead>
                <tr className="bg-blue-200 text-black">
                  <th className="py-2 px-4 border-b">
                    ¿Cuáles son tus objetivos inmediatos y que haces para
                    conseguirlos?
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="text-black">
                  <td className="py-2 px-4 border-b">
                    <Controller
                      name="objetivos_ps"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="objetivos_ps"
                          value={
                            field.value ||
                            `${queryConclusionPS.data?.objetivos_ps || ""}`
                          }
                          disabled={true}
                          onChange={field.onChange}
                          className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                          aria-label="objetivos_ps"
                          placeholder="Objetivos inmediatos"
                        />
                      )}
                    />
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div className="mt-2">
            <div className="flex items-center gap-2">
              <Label
                htmlFor="nombreFirma"
                className="text-sm font-semibold whitespace-nowrap ml-auto"
              >
                Nombre y Firma del Evaluado:
              </Label>
              <TextInput
                id="nombreFirma"
                name="nombreFirma"
                className="w-64 rounded-md py-1 text-sm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
